import React from "react"
import styled from "styled-components"
import { Calendar } from "lucide-react";
const importantDates = [
  { date: "2025-10-31", event: "Abstract Submission" },
  { date: "2025-07-31", event: "Early Bird registration" },
  { date: "2025-11-30", event: "Exhibition/Sponsorship" },
];

const ImportantDates = () => {
  return (
    <DetailBox>
      <ContentWrapper>
        <Title>Important Deadlines</Title>
        <DateCardList>
          {importantDates.map((item, index) => (
            <DateCard key={index}>
              <Icon />
              <Content>
                <EventName>{item.event}</EventName>
                <EventDate>{item.date}</EventDate>
              </Content>
            </DateCard>
          ))}
        </DateCardList>
      </ContentWrapper>
      <Footer>
        <FooterText>
          <Bold>Main Conference:</Bold> 9th - 12th December 2025, Accra, Ghana
        </FooterText>
      </Footer>
    </DetailBox>
  );
};

const DetailBox = styled.div`
  background-color: white;
  width: 90%;
  max-width: 500px;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  
  @media only screen and (min-width: 1000px) {
    width: 80%;
  }
`;

const ContentWrapper = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 150px;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
  
  @media only screen and (max-height: 700px) {
    max-height: 350px;
  }
  
  @media only screen and (max-height: 600px) {
    max-height: 250px;
  }
  
  @media only screen and (max-height: 500px) {
    max-height: 180px;
  }
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  margin: 0 0 20px 0;
  
  @media only screen and (max-height: 600px) {
    font-size: 1.3rem;
    margin: 0 0 15px 0;
  }
`;

const DateCardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  @media only screen and (max-height: 600px) {
    gap: 12px;
  }

`;

const DateCard = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 12px 16px;
  gap: 16px;
  
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
  
  @media only screen and (max-height: 600px) {
    padding: 8px 12px;
    gap: 12px;
    border-radius: 8px;
  }
`;

const Icon = styled(Calendar)`
  width: 24px;
  height: 24px;
  min-width: 24px;
  color: #082D4A;
  
  @media only screen and (max-height: 600px) {
    width: 20px;
    height: 20px;
    min-width: 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const EventName = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  
  @media only screen and (max-height: 600px) {
    font-size: 0.9rem;
  }
`;

const EventDate = styled.span`
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 2px;
  
  @media only screen and (max-height: 600px) {
    font-size: 0.8rem;
    margin-top: 1px;
  }
`;

const Footer = styled.div`
  background-color: #f5f5f5;
  padding: 12px 16px;
  border-top: 1px solid #eaeaea;
  text-align: center;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  
  @media only screen and (max-height: 600px) {
    padding: 8px 12px;
  }
`;

const FooterText = styled.p`
  margin: 0;
  font-size: 14px;
  color: rgb(177, 34, 34);
  
  
  @media only screen and (max-height: 600px) {
    font-size: 12px;
  }

`;

const Bold = styled.span`
  color: #333;
  font-weight: bold;
`;

export default ImportantDates;